
<template>
  <div class="active-light-mode power-platform">
    <div class="rn-section-gap bg-white">
      <div class="container">
        <SectionTitle
          :title="$t('pp_services.title')"
          :sectionTitleStyle="3"
          :description="$t('pp_services.description')"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />

        <section class="product-description radius-big my-5 border">
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-md-6 pe-md-5 col-12">
                <h3 class="h3 mb-4 color-desc-gray">
                  {{ $t("pp_services.productOverview.title") }}
                </h3>
                <p class="color-darker mb-6">
                  {{ $t("pp_services.productOverview.content") }}
                </p>
                <div class="d-flex flex-column flex-sm-row gap-4 mb-4">
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#trialModal"
                    class="btn btn-primary px-5 py-3 b2 d-flex justify-content-center radius align-items-center"
                  >
                    <i class="fa-solid fa-rocket me-2"></i>
                    <span>{{ $t("pp_services.buttons.freeTrial") }}</span>
                  </button>
                  <button
                    @click="imageIndex = 0"
                    class="btn bg-white text-primary border border-primary radius px-5 py-3 b2 d-flex justify-content-center align-items-center"
                  >
                    <i class="fa-solid fa-play-circle me-2"></i>
                    <span>{{ $t("pp_services.buttons.watchVideo") }}</span>
                  </button>
                </div>
              </div>
              <div class="col-md-6 col-12 p-0 overflow-hidden radius-big">
                <img
                  src="https://lf-code-agent.coze.cn/obj/x-ai-cn/259586967042/attachment/image_20250822060310.png"
                  alt="微扬审批流产品概述"
                  class="w-100 h-100 hover-scale"
                />
              </div>
            </div>
            <div class="video-lightbox-wrapper">
              <CoolLightBox
                :items="videoData"
                :index="imageIndex"
                @close="imageIndex = null"
              >
              </CoolLightBox>
            </div>
          </div>
        </section>

        <!--  主要特性部分  -->
        <section class="my-5">
          <h3 class="h3 text-center color-desc-gray">
            {{ $t("pp_services.coreFeatures.title") }}
          </h3>
          <div class="pb-5">
            <FeatureCard
              v-for="(feature, index) in localMainFeatures"
              :key="index"
              :title="feature.title"
              :description="feature.content"
              :icon="feature.icon"
              :imageUrl="feature.imageUrl"
              :index="index"
            />
          </div>
        </section>

        <!-- 其他特性部分 -->
        <section class="my-5">
          <h3 class="h3 mb-6 text-center color-desc-gray">
            {{ $t("pp_services.otherFeatures.title") }}
          </h3>
          <div class="row">
            <div
              v-for="(feature, index) in localOtherFeatures"
              :key="index"
              class="col-lg-4 col-md-6 col-12 mb-4"
            >
              <div
                class="d-flex items-start bg-white p-4 radius border border-vyung-border-color shadow-sm h-100"
              >
                <i
                  :class="[
                    'fa-solid',
                    `fa-${feature.icon || 'check'}`,
                    'text-primary',
                    'mr--10',
                  ]"
                ></i>
                <div>
                  <h5 class="h5 mb-2 color-desc-gray">
                    {{ feature.title }}
                  </h5>
                  <p class="text-sm m-0">
                    {{ feature.content }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          class="py-4 bg-vyung-main radius-big p-8 text-white text-center shadow"
        >
          <div class="p-4">
            <h3 class="h3 text-white">{{ $t("pp_services.contact.title") }}</h3>
            <p class="mb-4 text-white opacity-75">
              {{ $t("pp_services.contact.content") }}
            </p>
            <div class="d-md-flex w-50 mx-auto">
              <div v-for="item in contact" :key="item.icon" class="col-md-4">
                <i :class="`fa-solid mr--10 opacity-75 fa-${item.icon}`"></i>
                <a
                  :href="item.type + item.text"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-white"
                  >{{ item.text }}</a
                >
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <Copyright />
    <FreeTrial />
  </div>
</template>
<script>
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
import FeatureCard from "./Card";
import Copyright from "@/components/common/footer/Copyright";
import FreeTrial from "./FreeTrial";
import { mainFeatures, otherFeatures } from "./const";

export default {
  name: "DynamicsPowerPlatform",
  components: {
    SectionTitle,
    FeatureCard,
    Copyright,
    FreeTrial,
  },
  data() {
    return {
      // 审批工作流试用申请
      videoData: [
        {
          src:
            process.env.VUE_APP_VIDEO_URL +
            "/$web/video/workflow.mp4?" +
            process.env.VUE_APP_VIDEO_RAXWDL,
        },
      ],
      imageIndex: null,
      contact: [
        {
          icon: "envelope",
          text: "marketing@vyung.com",
          type: "mailto:",
        },
        {
          icon: "phone",
          text: "400-009-8870",
          type: "tel:",
        },
        {
          icon: "globe",
          text: "www.vyung.com",
          type: "",
        },
      ],
    };
  },
  computed: {
    localMainFeatures() {
      const featuresFromLang = this.$t("pp_services.coreFeatures.list");
      return featuresFromLang.map((feature, index) => ({
        ...feature,
        icon: mainFeatures[index]?.icon || "check",
        imageUrl: mainFeatures[index]?.imageUrl || "",
      }));
    },
    localOtherFeatures() {
      const featuresFromLang = this.$t("pp_services.otherFeatures.list");
      return featuresFromLang.map((feature, index) => ({
        ...feature,
        icon: otherFeatures[index]?.icon || "check",
      }));
    },
  },
};
</script>
